module.exports = __webpack_public_path__ + "img/barbecue.3a2989de.png";